import React from 'react';

import FeatureBoxList from '@components/FeatureBoxList';
import SaveTimeIcon from '@components/icons/SaveTimeIcon';
import CameraIcon from '@components/icons/CameraIcon';
import HomeCheckIcon from '@components/icons/HomeCheckIcon';

import './FeatureBoxSection.scss';

const featureList = [
  {
    icon: <CameraIcon />,
    description: 'Lister.landing.page-what.you.get1'
  },
  {
    icon: <SaveTimeIcon />,
    description: 'Lister.landing.page-what.you.get2'
  },
  {
    icon: <HomeCheckIcon />,
    description: 'Lister.landing.page-what.you.get3'
  }
];

const FeatureBoxSection = () => (
  <section className="feature-box-section">
    <FeatureBoxList featureList={featureList} />
  </section>
);

export default FeatureBoxSection;
